// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__V7Ko4","content":"not-found_content__1X3RS","title":"not-found_title__Gv4Fl"};